











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import * as rules from '@/utils/validationRules'
import { toSubArray } from '@/utils/groupBy'

@Component({
  name: 'EditFollowers',    
  components:{EditBaseFlux}
})
export default class EditFollowers extends Vue {
  
  private flux = getDefaultAloFlux()

  created(){
     this.$store.myActions.ADM_PERSONNE_ENSURE()
  }
    
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {            
    this.flux =  (this.$refs.baseEdit as EditBaseFlux).edit(item)  
  }  
  
  get followersIds() {
    return this.flux.followers.map(f => f.id)
  }

  set followersIds(ids) {
    this.flux.followers = ids.map(id => this.followerDic[id])
  }

  get followerDic(){
    return this.$store.myGetters.personneDic
  }

  get followersList() {    
    return this.$store.myGetters.personneList
  }

  get followersGroup(){
    return toSubArray(this.followersList,2)
  } 
  
}
